export class UserManagementRequest {

    constructor(public userName: string,
        public firstName: string,
        public lastName: string,
        public emailId: string,
        public phoneNumber: string) {
        
    }
}


/** WEBPACK FOOTER **
 ** ./app/main/userManagement/user-management-request.ts
 **/